import React from 'react';
import { Tag } from 'antd';
import { StarFilled } from '@ant-design/icons';
import { format } from 'date-fns';

const formatDate = (dateStr) => {
    if (!dateStr) return '—';
    try {
        const d = new Date(dateStr);
        if (Number.isNaN(d.getTime())) return dateStr;
        return format(d, 'do MMM yyyy');
    } catch {
        return dateStr;
    }
};

export const getPerformanceColumns = () => [
    {
        title: 'Employee',
        dataIndex: 'employee',
        key: 'employee',
        width: 220,
        render: (_, record) => (
            <div>
                <div style={{ fontWeight: 500 }}>{record.userName || '—'}</div>
                <div style={{ fontSize: 12, color: 'rgba(0,0,0,0.45)' }}>
                    {record.userEmail || '—'}
                </div>
            </div>
        ),
    },
    {
        title: 'Period',
        dataIndex: 'period',
        key: 'period',
        width: 220,
        render: (_, record) => {
            const { periodStart, periodEnd } = record;
            if (!periodStart && !periodEnd) return '—';
            const start = periodStart ? formatDate(periodStart) : '—';
            const end = periodEnd ? formatDate(periodEnd) : '—';
            return `${start} - ${end}`;
        },
    },
    { title: 'Note', dataIndex: 'note', key: 'note', ellipsis: true },
    {
        title: 'Metrics (%)',
        dataIndex: 'metrics',
        key: 'metrics',
        width: 260,
        render: (m) => {
            if (!m) return '—';
            const rows = [];
            if (m.project_deliveries != null) rows.push(`Projects ${m.project_deliveries}%`);
            if (m.attendance != null) rows.push(`Attendance ${m.attendance}%`);
            if (m.behaviour != null) rows.push(`Behaviour ${m.behaviour}%`);
            if (m.extra_caricullar_activities != null)
                rows.push(`Extra ${m.extra_caricullar_activities}%`);
            if (!rows.length) return '—';
            return (
                <div>
                    {rows.map((line) => (
                        <div key={line}>{line}</div>
                    ))}
                </div>
            );
        },
    },
    {
        title: 'Rating',
        dataIndex: 'rating',
        key: 'rating',
        width: 80,
        render: (v) =>
            v != null ? (
                <Tag color="gold">
                    <StarFilled style={{ marginRight: 4 }} />
                    {v}/5
                </Tag>
            ) : (
                '—'
            ),
    },
];
